export enum LineItemTab {
  DETAIL = 'detail',
  FULFILMENT = 'fulfilment',
}
